<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon metro-folder-open_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">体験ID範囲設定</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <div class="container">
      体験版として提供したい教材、分野、単元を選択してください
      <br />
      （※教材は2つまでしか選択できません）
      <hr class="divide-line" />
      <table class="table">
        <tbody>
          <tr v-for="trialCourse in setting.trialCourses" :key="trialCourse.id">
            <td width="30%">
              <v-select
                tag="div"
                v-model="trialCourse.book"
                placeholder="級・グレード"
                class="select-control"
                :clearable="false"
                :options="listOfBooksForCustomTrialCourse"
                label="name"
                @input="updateBook(trialCourse)"
              />
            </td>
            <td width="30%">
              <v-select
                tag="div"
                v-model="trialCourse.bookPart"
                placeholder="分野"
                class="select-control"
                :clearable="false"
                :options="getBookPartsFromTrialCourse(trialCourse)"
                label="name"
                @input="updateBookPart(trialCourse)"
              >
                <span slot="no-options">
                  先に級・グレードを選択してください
                </span>
              </v-select>
            </td>
            <td width="30%">
              <v-select
                tag="div"
                v-model="trialCourse.bookChapter"
                placeholder="単元"
                class="select-control"
                :clearable="false"
                :options="getBookChaptersFromTrialCourse(trialCourse)"
                label="name"
                @input="updateBookChapter(trialCourse)"
              >
                <span slot="no-options">
                  先に分野を選択してください
                </span>
              </v-select>
            </td>
            <td>
              <button class="btn-image">
                <img
                  src="@/assets/images/Button remove.png"
                  alt=""
                  width="27.3"
                  height="27.3"
                  @click="removeRange(trialCourse.id)"
                  v-show="canRemoveTrialCourse"
                />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn-image" @click="addNewTrialCourse">
        <img src="@/assets/images/Button add.png" alt="" width="27.3" height="27.3" />
      </button>
      <div class="m-5 text-center">
        <button type="button" :disabled="!trialCoursesReady" class="btn btn-red" @click="confirmCreated">
          作成
        </button>
      </div>
    </div>
    <div class="container">
      <div>専用体験コード一覧</div>
      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div>
            <b-table
              ref="trial-table"
              class="sticky-table table-auto-height"
              sticky-header
              responsive
              hover
              :items="trialCourseList"
              :fields="fields"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>
              <template v-slot:cell(index)="row">
                {{ row.index + 1 }}
              </template>

              <template v-slot:cell(createdAt)="row"> {{ trialCourseDatetimeDisplay(row.value) }} </template>

              <template v-slot:cell(books)="row">
                <span v-for="(book, index) in duplicateAndSortBooks(row.value)" :key="book.id">
                  {{ showMaterial(book.bookId) }}
                  {{ index + 1 != duplicateAndSortBooks(row.value).length ? '/' : '' }}
                </span>
                <div>
                  <span class="hyper-text" @click="toggleShowBook(row.item.id)">
                    詳細
                  </span>
                </div>
                <div :id="'bookDetail_' + row.item.id" class="hide">
                  <div v-for="book in sortBooks(row.value)" :key="book.id">
                    {{ showMaterialDetail(book.bookId, book.bookPartId, book.bookChapterId) }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(delete)="row">
                <div class="b-table-column-background-white">
                  <p @click="trialCoursesDeletionConfirmation(row.item.id, row.item.code)" class="hyper-text">
                    削除
                  </p>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>体験ID範囲設定</template>
        <template v-slot:body>
          発行が完了しました！
          <br />
          発行コード： {{ createdCode }}
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder_warning"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="warningPopupOKClicked"
      >
        <template v-slot:header>教材は2つまでしか選択できません</template>
        <template v-slot:body>選択した単元が属する教材が２つ以下になるように選択し直してください</template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder_delete"
        no-close-on-esc
        no-close-on-backdrop
        show-red-button
        green-button-title="戻る"
        red-button-title="実行"
        @greenClick="popupCancelled"
        @redClick="popupDeleteConfirmed"
      >
        <template v-slot:header>ID発行用コードの削除</template>
        <template v-slot:body>
          <p>発行用コード: {{ targetCode }}</p>
          本当に削除しますか？<br />
          <span class="text-danger">
            ※ このコードで発行した全塾さまの体験IDも全て削除されます。 <br />
            ※ この操作を行うと二度と元に戻せません。
          </span>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder_delete_success"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>削除完了</template>
        <template v-slot:body>
          削除が完了しました。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder_delete_failed"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupCancelled"
      >
        <template v-slot:header>削除失敗</template>
        <template v-slot:body>
          削除に失敗しました。もう一度お試しください。
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import sortBy from 'lodash/sortBy';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { basicDatetime } from '@/presenters/fields';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';

export default {
  components: {
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch('setting/fetchBooks').then(() => {
      store.dispatch('setting/fetchTrialCourses').then(() => {
        next();
      });
    });
  },
  data() {
    return {
      targetId: 0,
      targetCode: '',
      createdCode: '',
      fields: [
        {
          key: 'index',
          label: 'No',
          sortable: true,
        },
        {
          key: 'code',
          label: 'コード',
          sortable: true,
        },
        {
          key: 'books',
          label: '教材',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: '作成日',
          sortable: true,
        },
        {
          key: 'delete',
          label: '処理',
        },
      ],
    };
  },
  computed: {
    trialCoursesReady() {
      if (this.trialCourses.length == 0) {
        return false;
      }
      for (const trialCourse of this.trialCourses) {
        if (trialCourse.book == null || trialCourse.bookPart == null || trialCourse.bookChapter == null) {
          return false;
        }
      }
      return true;
    },
    canRemoveTrialCourse() {
      return this.trialCourses.length > 1;
    },
    ...mapState(['setting']),
    ...mapState({
      trialCourses: (state) => state.setting.trialCourses,
      trialCourseList: (state) => state.setting.trialCourseList,
      bookList: (state) => state.setting.books,
    }),
    ...mapGetters('setting', [
      'getBookPartsFromTrialCourse',
      'getBookChaptersFromTrialCourse',
      'listOfBooksForCustomTrialCourse',
    ]),
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({
        leftColumns: 4,
        rightColumns: 1,
      });
    },
    createFreshExperienceRangeObject() {
      const id = Math.floor(Math.random() * 10000000);
      this.$logger.debug('Preparing new Range with ID ' + id);
      return {
        id: id,
        book: null,
        bookPart: null,
        bookChapter: null,
      };
    },
    addNewTrialCourse() {
      const newRange = this.createFreshExperienceRangeObject();
      this.$logger.debug('Added new Range: ' + JSON.stringify(newRange));
      this.addTrialCourse(newRange);
    },
    updateBook(trialCourse) {
      trialCourse.bookPart = null;
      trialCourse.bookChapter = null;
      this.$logger.debug('Update existing Trial Course Book: ' + JSON.stringify(trialCourse));
      this.updateTrialCourse(trialCourse);
    },
    updateBookPart(trialCourse) {
      trialCourse.bookChapter = null;
      this.$logger.debug('Update existing Trial Course Book Part: ' + JSON.stringify(trialCourse));
      this.updateTrialCourse(trialCourse);
    },
    updateBookChapter(trialCourse) {
      this.$logger.debug('Update existing Trial Course Book Chapter: ' + JSON.stringify(trialCourse));
      this.updateTrialCourse(trialCourse);
    },
    removeRange(id) {
      this.$logger.debug('Removed existing Range with Id: ' + id);
      this.deleteTrialCourse(id);
    },
    confirmCreated() {
      this.$logger.debug('Confirm created');

      let teachingMaterialCodeList = [];
      for (const trialCourse of this.trialCourses) {
        if (trialCourse.book) {
          const teachingMaterialCode = trialCourse.book.teachingMaterialCode;
          if (teachingMaterialCodeList.indexOf(teachingMaterialCode) == -1) {
            teachingMaterialCodeList.push(teachingMaterialCode);
          }
        }
      }
      if (teachingMaterialCodeList.length > 2) {
        this.$refs['popup_holder_warning'].show();
      } else {
        this.createTrialCourses().then((response) => {
          this.createdCode = response;
          this.$logger.debug('Show success popup');
          this.$refs['popup_holder'].show();
        });
      }
    },
    warningPopupOKClicked() {},

    popupConfirmed() {
      store.dispatch('setting/fetchTrialCourses');
    },
    trialCoursesDeletionConfirmation(id, code) {
      this.targetId = id;
      this.targetCode = code;
      this.$logger.debug('DeletionConfirmation trialCourses with Id: ' + id);
      this.$refs['popup_holder_delete'].show();
    },
    popupDeleteConfirmed() {
      this.deleteTrialCourseFromDB(this.targetId)
        .then(() => {
          this.$refs['popup_holder_delete_success'].show();
        })
        .catch((err) => {
          this.$logger.error(err);
          this.$refs['popup_holder_delete_failed'].show();
        });
    },
    popupCancelled() {
      this.$logger.debug('Popup cancelled');
    },
    ...mapActions('setting', [
      'updateTrialCourse',
      'addTrialCourse',
      'deleteTrialCourse',
      'createTrialCourses',
      'deleteTrialCourseFromDB',
    ]),
    ...mapActions('book', ['fetchBooks', 'fetchBookParts', 'fetchBookChapters']),
    trialCourseDatetimeDisplay(date) {
      return basicDatetime(date);
    },
    showMaterial(bookId) {
      let bookText = '';
      if (bookId) {
        const bookIdIndex = this.bookList.findIndex((bookArray) => bookArray.id === bookId);
        bookText = this.bookList[bookIdIndex].name;
      }
      return `${bookText}`;
    },
    showMaterialDetail(bookId, partId, chapterId) {
      let bookText = '';
      let partText = '';
      let chapterText = '';
      if (bookId) {
        const bookIdIndex = this.bookList.findIndex((bookArray) => bookArray.id === bookId);
        bookText = this.bookList[bookIdIndex].name;
        if (partId) {
          const partIdIndex = this.bookList[bookIdIndex].bookParts.findIndex((partArray) => partArray.id === partId);
          partText = this.bookList[bookIdIndex].bookParts[partIdIndex].name;
          if (chapterId) {
            const chapterIdIndex = this.bookList[bookIdIndex].bookParts[partIdIndex].bookChapters.findIndex(
              (chapterArray) => chapterArray.id === chapterId
            );
            chapterText = this.bookList[bookIdIndex].bookParts[partIdIndex].bookChapters[chapterIdIndex].name;
          }
        }
      }
      return `${bookText} > ${partText} > ${chapterText}`;
    },

    duplicateAndSortBooks(rowBooks) {
      const duplicatedBooks = _.unionBy(rowBooks, 'bookId');
      const sortedBooks = sortBy(duplicatedBooks, 'bookId');
      return sortedBooks;
    },
    sortBooks(rowBooks) {
      return sortBy(rowBooks, 'bookId');
    },
    toggleShowBook(id) {
      const targetElement = document.getElementById(`bookDetail_${id}`);
      if (targetElement.classList.contains('show')) {
        targetElement.classList.remove('show');
      } else {
        targetElement.classList.add('show');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-red {
  margin-left: 0px;
}
.divide-line {
  background-color: black;
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.hide {
  display: none;
}
.show {
  display: block;
}
/deep/ tr {
  &:hover {
    background-color: B5D3FF;
    td {
      z-index: 1;
      background-color: transparent;
    }
  }
}
</style>
